import { FetchResult } from 'src/types/TApiQueries';
import {
  ChannelPresetsResponse,
  GenerateRequest,
  GenerateResponse,
  CampaignPreset,
  CampaignPresetKind,
  CampaignPresetPayload,
  CampaignPresetsResponse,
  CampaignPresetResponse,
} from 'src/types/TCampaignLinks';
import { config } from 'src/utils/config';
import { getStandardHeaders, performFetchWithLogging } from '../utils/helpers';

const baseUrl = config.hostUrl;
const root = `${baseUrl}/api/v1/campaign-links`;

export async function getChannelPresets(
  accessToken: string,
): Promise<FetchResult<ChannelPresetsResponse>> {
  return performFetchWithLogging(`${root}/channel-presets`, {
    method: 'GET',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

export async function generateCampaignLinks(
  payload: GenerateRequest,
  accessToken: string,
): Promise<FetchResult<GenerateResponse>> {
  return performFetchWithLogging(`${root}/generate`, {
    method: 'POST',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(payload),
  });
}

export async function listCampaignPresets(
  accessToken: string,
  kind?: CampaignPresetKind,
): Promise<FetchResult<CampaignPresetsResponse>> {
  const qs = kind ? `?kind=${kind}` : '';
  return performFetchWithLogging(`${root}/presets${qs}`, {
    method: 'GET',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

export async function createCampaignPreset(
  payload: { kind: CampaignPresetKind; name: string; payload: CampaignPresetPayload },
  accessToken: string,
): Promise<FetchResult<CampaignPresetResponse>> {
  return performFetchWithLogging(`${root}/presets`, {
    method: 'POST',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(payload),
  });
}

export async function updateCampaignPreset(
  presetId: number,
  payload: { kind: CampaignPresetKind; name: string; payload: CampaignPresetPayload },
  accessToken: string,
): Promise<FetchResult<CampaignPresetResponse>> {
  return performFetchWithLogging(`${root}/presets/${presetId}`, {
    method: 'PUT',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
    body: JSON.stringify(payload),
  });
}

export async function deleteCampaignPreset(
  presetId: number,
  accessToken: string,
): Promise<FetchResult<{ status: string }>> {
  return performFetchWithLogging(`${root}/presets/${presetId}`, {
    method: 'DELETE',
    headers: getStandardHeaders(accessToken),
    credentials: 'include',
  });
}

export type { CampaignPreset };
